import Vue from 'vue'
import LazyImage from '@/components/global/LazyImage'

Vue.component('LazyImg', LazyImage)
